import BaseZeroAction from './BaseZeroAction.js';

class SubmitZeroAction extends BaseZeroAction {}

export default SubmitZeroAction;
